import type { GetStaticProps, NextPage } from "next";
import Layout from "../components/Layout";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { Container } from "react-bootstrap";
import { caseStudies } from "../routes/namespaces";
import { CaseStudiesItems } from "../components/CaseStudies/CaseStudies/index";
import { QueryClient, dehydrate } from "@tanstack/react-query";
import { fetchCaseStudies } from "data/caseStudies";

const CaseStudies: NextPage = () => {
  const { t } = useTranslation(["case-studies", "navigation"]);

  return (
    <Layout title={t("caseStudies", { ns: "navigation" })}>
      <Container className="pt-10 text-center">
        <h1 className="mt-7 mb-8 text-uppercase">{t("title")}</h1>
      </Container>
      <CaseStudiesItems />
    </Layout>
  );
};

export default CaseStudies;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const queryClient = new QueryClient();

  if (locale) {
    await queryClient.prefetchQuery(
      ["case-studies", { locale: locale }],
      fetchCaseStudies
    );
  }

  return {
    revalidate: 3600,
    props: {
      ...(await serverSideTranslations(
        locale || "cs",
        caseStudies
      )),
      dehydratedState: dehydrate(queryClient),
    },
  };
};
